import { type ReactNode, type FC } from 'react';
import { InputText } from '@g2u/ui-kit';

import { type WithOptionalDataTest } from 'types';

type Props = {
  name?: string;
  className?: string;
  label?: string | ReactNode;
  required?: boolean;
  placeholder?: string;
  initialValue?: string;
} & WithOptionalDataTest;

export const InputName: FC<Props> = (props) => {
  const {
    className,
    name = 'name',
    label = 'Name:',
    required = true,
    dataTestId = 'name',
    placeholder = 'Input',
    initialValue,
    ...antProps
  } = props;

  return (
    <InputText.$
      dataTestId={dataTestId}
      name={name}
      className={className}
      label={label}
      required={required}
      rules={[{ required }, { pattern: /^[a-z ,.'-]+$/i, message: 'Incorrect name format' }]}
      fullWidth
      placeholder={placeholder}
      initialValue={initialValue}
      {...antProps}
    />
  );
};
